<template>
    <div>
        <b-row>
            <b-col>
                <el-input size="small"
                          placeholder="Buscar"
                          v-model="params.filter"
                />
            </b-col>

            <b-col>
                <b-button variant="primary"
                          @click="fetchTrainings(true)"
                          :disabled="!params.company_id"
                          size="sm"
                          class="mx-1"
                >
                    <i class="fa fa-search"/>
                    <span class="d-none d-md-inline-block ml-1"
                          v-text="' Buscar'"
                    />
                </b-button>

                <b-button :disabled="!params.company_id"
                          @click="resetParamsFilter"
                          size="sm"
                          class="mx-1"
                >
                    <i class="fa fa-eraser"/>
                    <span class="d-none d-md-inline-block ml-1"
                          v-text="' Limpiar'"
                    />
                </b-button>

                <b-dropdown v-if="validarPermisoComponente('empresa-editar-capacitaciones')"
                            id="options"
                            size="sm"
                            variant="primary"
                            text="Opciones"
                            class="float-right"
                            :disabled="!params.company_id"
                >
                    <b-dropdown-item @click="openModalForCreation()">
                        <i class="fa fa-plus"/> Crear
                    </b-dropdown-item>
                    <b-dropdown-item @click="downloadTemplate">
                        <i class="fa fa-download"/> Descargar plantilla
                    </b-dropdown-item>
                    <b-dropdown-item @click="setShowToModalUpload(true)">
                        <i class="fa fa-upload"/> Carga masiva
                    </b-dropdown-item>
                </b-dropdown>
            </b-col>
        </b-row>

        <b-table hover
                 striped
                 responsive
                 :fields="columns"
                 show-empty
                 empty-text="No hay capacitaciones para mostrar"
                 :items="trainings.data"
                 class="mt-3"
        >

            <template v-if="validarPermisoComponente('empresa-editar-capacitaciones')" v-slot:cell(actions)="data">
                <el-tooltip popper-class="py-1 px-2"
                            effect="dark"
                            placement="top-start"
                            content="Editar"
                >
                    <b-btn variant="primary"
                           class="mx-1"
                           size="sm"
                           @click="openModalForEdition(data.item)"
                    >
                        <i class="fa fa-edit"/>
                    </b-btn>
                </el-tooltip>

                <el-tooltip popper-class="py-1 px-2"
                            effect="dark"
                            placement="top-start"
                            content="Eliminar"
                >
                    <b-btn variant="danger"
                           class="mx-1"
                           size="sm"
                           @click="deleteTraining(data.item.id)"
                    >
                        <i class="fa fa-trash"/>
                    </b-btn>
                </el-tooltip>
            </template>


        </b-table>

        <!-- Paginación -->
        <el-pagination v-if="trainings.data && !!trainings.data.length"
                       v-model="params.page"
                       @size-change="fetchTrainings()"
                       @current-change="fetchTrainings()"
                       :current-page.sync="params.page"
                       class="float-right"
                       :page-size.sync="params.per_page"
                       :page-sizes="[10, 30, 50, 100]"
                       layout="total, sizes, prev, pager, next"
                       :total="trainings.total"
        />

        <modal/>
        <modal_upload/>
    </div>
</template>

<script>
import {mapActions, mapMutations, mapState} from 'vuex';
import modal from './modal.vue';
import modal_upload from './modal_upload.vue';
import { validarPermisoComponente } from "@/plugins/acl";

export default {
    name: 'index',
    components: {
        modal,
        modal_upload
    },
    data() {
        return {
            company_id: this.$route.params.id,
            validarPermisoComponente: validarPermisoComponente,
        };
    },
    computed: {
        ...mapState('trainings', [
            'trainings',
            'params',
            'companies'
        ]),

        columns() {
            const columnsBase = [
                {
                    key: 'code',
                    label: 'Código',
                    thStyle: 'width: 200px'
                },
                {
                    key: 'name',
                    label: 'Nombre'
                },
                {
                    key: 'wor_training_company.name',
                    label: 'Empresa formadora'
                },
                {
                    key: 'intensity',
                    label: 'Intensidad'
                },
            ];

            if (this.validarPermisoComponente('empresa-editar-capacitaciones')) {
                columnsBase.push({
                    key: 'actions',
                    label: 'Acciones',
                    thStyle: 'width: 150px',
                    tdClass: 'text-nowrap text-right'
                });
            }

            return columnsBase;
        },
    },
    async mounted() {
        this.resetParams();
        this.params.company_id = this.company_id;
        await this.fetchTrainings(true);
        await this.fetchData();
        this.load(false);
    },
    methods: {
        ...mapActions('trainings', [
            'fetchCompanies',
            'fetchTrainingCompanies',
            'fetchTrainings',
            'fetchWorkers',
            'getTraining',
            'deleteTraining',
            'getLastTraining',
            'downloadTemplate'
        ]),
        ...mapMutations('trainings', [
            'setModalShow',
            'resetParams',
            'setEditing',
            'resetTraining',
            'setShowToModalUpload'
        ]),
        ...mapMutations('dashboard', ['load']),
        async openModalForCreation() {
            this.resetTraining();
            await this.getLastTraining();
            this.setEditing(false);
            this.setModalShow(true);
        },
        async openModalForEdition(training) {

            await this.getTraining(training.id);

            this.setEditing(true);
            this.setModalShow(true);
        },
        async fetchData() {
            await this.fetchWorkers(this.company_id);
            await this.fetchTrainingCompanies(this.company_id);
        },
        async resetParamsFilter() {
            this.resetParams();
            this.params.company_id = this.company_id;
            await this.fetchTrainings(true);
        }
    },
};
</script>

<style scoped>
</style>
